import useActionThread from './useActionThread'
import useActionComment from './useActionComment'

export default {
  useActionThread,
  useActionComment,
}
